
/* =========================================================
   WORKFLOW
========================================================= */

import React from "react";

const Workflow = ({ data }) => (
    <div className="workflow">

        {data.map((item, i) => (
            <div className="workflow-step" key={i}>

                <div className="workflow-circle">
                    {String(i + 1).padStart(2, "0")}
                </div>

                <h4>{item.title}</h4>

                <p>{item.description}</p>

            </div>
        ))}

    </div>
);

export default Workflow;